import React from "react";
import { Button, Modal, Spin } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import styles from "./style.module.scss";

const EmailPreviewPanel = ({
  open,
  loading,
  html,
  subject,
  onClose,
  isMobile,
}) => {
  const { t } = useTranslation();

  const body = (
    <div className={styles.previewBody}>
      <p className={styles.previewNote}>{t("email_reports_page.previewNote")}</p>
      {subject ? <p className={styles.previewSubject}>{subject}</p> : null}
      {loading ? (
        <div className={styles.previewLoading}>
          <Spin tip={t("email_reports_page.previewLoading")} />
        </div>
      ) : html ? (
        <iframe
          title={t("email_reports_page.previewTitle")}
          className={styles.previewFrame}
          srcDoc={html}
          sandbox="allow-same-origin"
        />
      ) : (
        <p className={styles.previewEmpty}>{t("email_reports_page.previewEmpty")}</p>
      )}
    </div>
  );

  if (isMobile) {
    return (
      <Modal
        open={open}
        onCancel={onClose}
        footer={null}
        width="100%"
        style={{ top: 0, maxWidth: "100vw", padding: 0 }}
        styles={{ body: { padding: 0 } }}
        className={styles.previewModal}
        closable={false}
        destroyOnClose
      >
        <div className={styles.previewMobileHeader}>
          <span>{t("email_reports_page.previewTitle")}</span>
          <Button type="text" icon={<CloseOutlined />} onClick={onClose} aria-label={t("email_reports_page.previewClose")} />
        </div>
        {body}
      </Modal>
    );
  }

  if (!open) return null;

  return (
    <aside className={styles.previewPanel} aria-label={t("email_reports_page.previewTitle")}>
      <div className={styles.previewPanelHeader}>
        <span>{t("email_reports_page.previewTitle")}</span>
        <Button
          type="text"
          size="small"
          icon={<CloseOutlined />}
          onClick={onClose}
          aria-label={t("email_reports_page.previewClose")}
        />
      </div>
      {body}
    </aside>
  );
};

export default EmailPreviewPanel;
